// If you are adding something here, don't forget to add the key to: Infrastructure\public\RMA.Public.UI.Infrastructure\environment-settings.json
import type { DcEnvironmentCode, DcTenantCode } from '@rma/generic/core/instance';

export type CountryCode = 'AU' | 'NZ' | 'US' | 'CA';

/**
 * This is a class and not an interface so we don't need use @Inject(Environment) everywhere we inject it
 */
export class Environment {
  public version!: string;
  public type!: DcEnvironmentCode;
  public domain!: string;

  public googleMapKey!: string;
  public countryCode!: CountryCode;
  public tenantCode!: DcTenantCode;

  public datadomeJsKey?: string;
  public datadomeBypassPublicKey?: string;
  public launchDarklyClientId!: string;
  public recaptchaSiteKey!: string;
  public securePrivacyApiKey?: string;
  public securePrivacyId?: string;

  public social!: {
    facebookId: string;
    facebookUrl: string;

    twitterName: string;
    twitterUrl: string;

    linkedinUrl: string;
    instagramUrl: string;
  };

  public tracking!: {
    hotjarId?: string;
    heapAppId?: string;
    facebookPixelId?: string;
    googleTagManagerWebId?: string;

    googleTagManagerMegaphone?: string;
    googleAnalytics: {
      optimizeContainerId?: string;
      optimizeMeasurementId?: string;
      ga4?: string;
    };
    googleGlobalSiteTag?: {
      adConversionId?: string;
      phoneRevealAdConversionLabel?: string;
      callClickAdConversionLabel?: string;
      smsClickAdConversionLabel?: string;
      contactFormCompletionAdConversionLabel?: string;
    };
  };

  public identity!: {
    client: string;
    secret: string;
    jwtEnvironment: string;
  };

  public language!: {
    lokaliseAppId?: string;
    locale: string;
    supportedLocales?: string[];
    url: string;
    site?: string;
  };
}
